export default __webpack_public_path__ + "static/media/open-tender-landing.7dae7caf.jpg";